 
import {Bookmark24Regular} from "@fluentui/react-icons";
import {Button} from "@fluentui/react-components";

interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

export const SavedPromptsButton = ({className, disabled, onClick}: Props) => {
    return (
        <div className={`${className ?? ""}${disabled ? " disabled-opacity" : ""}`}>
            <Button
                icon={<Bookmark24Regular />}
                disabled={disabled}
                onClick={onClick}
            >
                {"Saved prompts"}
            </Button>
        </div>
    );
};
